import {FC, useEffect} from 'react'
import styles from './Notification.module.css'

type NotificationType = 'error' | 'success' | 'warning' | 'info'

interface NotificationProps {
  message: string
  type?: NotificationType
  show: boolean
  onClose: () => void
  duration?: number
}

const Notification: FC<NotificationProps> = ({
  message,
  type = 'error',
  show,
  onClose,
  duration = 5000,
}) => {
  useEffect(() => {
    if (show && duration > 0) {
      const timer = setTimeout(() => {
        onClose()
      }, duration)
      return () => clearTimeout(timer)
    }
  }, [show, duration, onClose])

  if (!show) return null

  const getIcon = () => {
    switch (type) {
      case 'error':
        return 'bi-exclamation-circle-fill'
      case 'success':
        return 'bi-check-circle-fill'
      case 'warning':
        return 'bi-exclamation-triangle-fill'
      case 'info':
        return 'bi-info-circle-fill'
      default:
        return 'bi-exclamation-circle-fill'
    }
  }

  const getBorderColor = () => {
    switch (type) {
      case 'error':
        return '#F1416C'
      case 'success':
        return '#50CD89'
      case 'warning':
        return '#FFC700'
      case 'info':
        return '#7239EA'
      default:
        return '#F1416C'
    }
  }

  return (
    <div
      className={styles.notification}
      style={{
        borderLeftColor: getBorderColor(),
      }}
    >
      <div className={styles.content}>
        <i className={`bi ${getIcon()}`} style={{color: getBorderColor()}}></i>
        <span>{message}</span>
      </div>
      <button onClick={onClose} className={styles.closeButton}>
        <i className='bi bi-x-lg'></i>
      </button>
    </div>
  )
}

export {Notification}
